import { FileText } from 'lucide-react';

/**
 * Scratch 题目作答设置区
 * 显示固定规则：仅允许提交 .sb3 文件
 */
export default function ScratchAnswerConfig() {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 px-4 py-3 bg-blue-50 rounded-lg border border-blue-100">
        <FileText className="w-4 h-4 text-blue-600 shrink-0" />
        <span className="text-sm text-blue-700">
          学生需提交 Scratch 项目文件（.sb3 格式），仅允许上传 1 个文件，文件大小不限
        </span>
      </div>
    </div>
  );
}
